export const useSettingsStore = defineStore(
	"settingsStore",
	() => {
		const currentEventId = ref("")
		const currentPageTitle = ref("")
		const showBackBtn = ref(false)
		const hideTopNav = ref(false)
		const dismissedExtraItemsBanner = ref(false)

		const setCurrentEventId = (value: string) => (currentEventId.value = value)

		// @ts-ignore
		const setCurrentPageTitle = (value: string) => (currentPageTitle.value = value ?? "")
		const clearCurrentPageTitle = () => (currentPageTitle.value = "")

		const setShowBackBtn = (value: boolean) => (showBackBtn.value = value)

		const setHideTopNav = (value: boolean) => (hideTopNav.value = value)

		const setDismissedExtraItemsBanner = (value: boolean) => (dismissedExtraItemsBanner.value = value)

		const $reset = () => {
			currentEventId.value = ""
			currentPageTitle.value = ""
			showBackBtn.value = false
			hideTopNav.value = false
			dismissedExtraItemsBanner.value = false
		}

		return {
			currentEventId,
			setCurrentEventId,
			currentPageTitle,
			setCurrentPageTitle,
			clearCurrentPageTitle,
			showBackBtn,
			setShowBackBtn,
			hideTopNav,
			setHideTopNav,
			dismissedExtraItemsBanner,
			setDismissedExtraItemsBanner,
			$reset,
		}
	},
	{
		persist: {
			key: "up_settingsStore", // Make sure this key is unique
			storage: localStorage, // or cookies if you're using cookie storage
			omit: ["dismissedExtraItemsBanner"], // blacklist: this property will NOT be persisted
		},
	},
)
